import React from "react";
import BackButton from "../../main/BackButton";
import Video from "../../main/Video";

const Collection9Video = () => {
  return (
    <>
      <BackButton url="/allvideos" />
      <Video
        url={`https://yuriy-dmytrash19.wistia.com/medias/twxiww073n`}
        maxHeight="80%"
      />
    </>
  );
};

export default Collection9Video;
